<div class="slideshow" [style.width]="width" [style.height]="height" [style.display]="display" [style.backgroundColor]="backgroundColour">
    <ng-content></ng-content>
    <div class="dots-wrapper">
        <div class="dot" *ngFor="let dot of dots" (click)="dotClicked(dot)" [ngClass]="{ 'dot-current': dot == currentIndex }"></div>
    </div>
    <i class="arrow arrow-left ti ti-angle-left" (click)="arrowChangeSlide(-1)"></i>
    <i class="arrow arrow-right ti ti-angle-right" (click)="arrowChangeSlide(1)"></i>
</div>